import { APP_MODE } from '@/stores/authStore';
import { Database, Server } from 'lucide-react';

export function ModeBanner() {
    const isReal = APP_MODE === 'real';
    const Icon = isReal ? Server : Database;
    return (
        <div
            role="status"
            className={`flex items-center justify-center gap-2 py-1 text-[10px] font-semibold uppercase tracking-wider ${
                isReal
                    ? 'bg-green-500/15 border-b border-green-500/30 text-green-300'
                    : 'bg-blue-500/15 border-b border-blue-500/30 text-blue-300'
            }`}
        >
            <Icon className="w-3 h-3" />
            {isReal ? 'REAL · backend TEST' : 'MOCK · dati finti'}
            <span className="text-zinc-500 font-normal normal-case">· anteprima UX</span>
        </div>
    );
}
